"use strict";

var cov_2eeqpptc7p = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/application-bar/ApplicationBar.js";
  var hash = "f1ddddf276d67ff10c73c3257e5d715912d56c6c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/application-bar/ApplicationBar.js",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 18
        },
        end: {
          line: 21,
          column: 29
        }
      },
      "1": {
        start: {
          line: 22,
          column: 26
        },
        end: {
          line: 22,
          column: 49
        }
      },
      "2": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 48,
          column: 4
        }
      },
      "3": {
        start: {
          line: 51,
          column: 0
        },
        end: {
          line: 58,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "ApplicationBar",
        decl: {
          start: {
            line: 16,
            column: 9
          },
          end: {
            line: 16,
            column: 23
          }
        },
        loc: {
          start: {
            line: 20,
            column: 3
          },
          end: {
            line: 49,
            column: 1
          }
        },
        line: 20
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 39,
            column: 38
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 39,
            column: 20
          },
          end: {
            line: 39,
            column: 33
          }
        }, {
          start: {
            line: 39,
            column: 36
          },
          end: {
            line: 39,
            column: 38
          }
        }],
        line: 39
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "f1ddddf276d67ff10c73c3257e5d715912d56c6c"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

require("@material-ui/icons");

var _useStyles = require("./useStyles");

var _ = require("..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ApplicationBar(_ref) {
  var title = _ref.title,
      buttons = _ref.buttons,
      drawerMenu = _ref.drawerMenu;
  cov_2eeqpptc7p.f[0]++;
  var classes = (cov_2eeqpptc7p.s[0]++, (0, _useStyles.useStyles)());

  var _ref2 = (cov_2eeqpptc7p.s[1]++, (0, _react.useContext)(_.FileContext)),
      file = _ref2.state;

  cov_2eeqpptc7p.s[2]++;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    position: "static",
    className: classes.appBar
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    "data-test": "application-bar"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.menuButton
  }, /*#__PURE__*/_react.default.createElement(_.DrawerMenu, null, drawerMenu)), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6",
    color: "inherit",
    className: classes.grow,
    noWrap: true
  }, title), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle2",
    color: "inherit",
    className: classes.grow,
    noWrap: true
  }, file ? (cov_2eeqpptc7p.b[0][0]++, file.filepath) : (cov_2eeqpptc7p.b[0][1]++, '')), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.grow
  }), buttons, /*#__PURE__*/_react.default.createElement(_.RepositoryMenu, null), /*#__PURE__*/_react.default.createElement(_.UserMenu, null))));
}

cov_2eeqpptc7p.s[3]++;
ApplicationBar.propTypes = {
  /** The title string to be displayed. */
  title: _propTypes.default.string,

  /** Additional buttons to be displayed. */
  buttons: _propTypes.default.element,

  /** Component to render inside of the drawer menu. */
  drawerMenu: _propTypes.default.element
};
var _default = ApplicationBar;
exports.default = _default;